import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import dispatchApi from './DispatchApi';
import { dispatchActions } from './DispatchSlice';
import { HTTP_RESPONSE_STATUS } from '../../../../../setup/constants/Http';
import { ToastDefaultConfig } from '../../../../../setup/toast/ToastConfig';
import {GetZoneRequest, HousingResponse, ProvinceResponse, ZoneResponse } from '../models';
import { ResponseArray, ListResponse } from '../../../../../setup/axios/HttpResponse';
import { ZoneListResponse } from '../../zones/models';
import { OperationHoursAndMap } from 'app/modules/users/models/OperationHoursAndMap';

// function* fetchProvinceList(): Generator<any, void, any> {
//   try {
//     const response: ResponseArray<ProvinceResponse> = yield call(zoneApi.getProvince);
//     if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
//       yield put(zoneActions.fetchProvinceListSuccess(response.data));
//     } else {
//       toast.error(response.message || 'Failed to fetch province list', ToastDefaultConfig());
//       yield put(zoneActions.fetchProvinceListFailed(response.message || 'Failed to fetch province list'));
//     }
//   } catch (error: any) {
//     toast.error(error.message || 'Failed to fetch province list', ToastDefaultConfig());
//     yield put(zoneActions.fetchProvinceListFailed(error.message || 'Failed to fetch province list'));
//   }
// }

// function* fetchHousingList(action: PayloadAction<GetHousingRequest>): Generator<any, void, any> {
//   try {
//     const response: ResponseArray<HousingResponse> = yield call(zoneApi.getHousing, action.payload.provinceId);
//     if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
//       yield put(zoneActions.fetchHousingListSuccess(response.data));
//     } else {
//       toast.error(response.message || 'Failed to fetch housing list', ToastDefaultConfig());
//       yield put(zoneActions.fetchHousingListFailed(response.message || 'Failed to fetch housing list'));
//     }
//   } catch (error: any) {
//     toast.error(error.message || 'Failed to fetch housing list', ToastDefaultConfig());
//     yield put(zoneActions.fetchHousingListFailed(error.message || 'Failed to fetch housing list'));
//   }
// }

function* fetchZoneList(action: PayloadAction<GetZoneRequest>): Generator<any, void, any> {
  try {
    const response: ListResponse<ZoneResponse> = yield call(dispatchApi.getZone, action.payload);
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      const transformedResponse: ZoneListResponse = {
        data: response.data.rows || [],
        total: response.data.pagination?.totalRows || 0,
      };
      yield put(dispatchActions.fetchZoneListSuccess(transformedResponse));
    } else {
      toast.error(response.message || 'Failed to fetch zone list', ToastDefaultConfig());
      yield put(dispatchActions.fetchZoneListFailed(response.message || 'Failed to fetch zone list'));
    }
  } catch (error: any) {
    toast.error(error.message || 'Failed to fetch zone list', ToastDefaultConfig());
    yield put(dispatchActions.fetchZoneListFailed(error.message || 'Failed to fetch zone list'));
  }
}

function* fetchOperationHoursAndMap() {
  try {
      const response: ResponseArray<OperationHoursAndMap> = yield call(dispatchApi.getClusterWorkingHours);
      if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
        yield put(dispatchActions.fetchOperationHoursAndMapDataSuccess(response.data));
      } else {
          toast.error(response.message, ToastDefaultConfig());
          yield put(dispatchActions.fetchOperationHoursAndMapDataFailed());
      }
  } catch (error: any) {
      yield put(dispatchActions.fetchOperationHoursAndMapDataFailed());
  }
}

export function* dispatchSaga() {
  yield takeLatest(dispatchActions.fetchZoneListStart.type, fetchZoneList);
  yield takeLatest(dispatchActions.fetchOperationHoursAndMapData, fetchOperationHoursAndMap);
}


export default dispatchSaga;

